import React from 'react'
import { getActiveSpecialHours, LOCATIONS } from '../lib/open-jump-hours'
import OpenJumpPrice from './open-jump-price'

const MODAL_STORAGE_KEY = 'holiday-oj-modal-shown'

export default class OpenJumpModal extends React.Component {
  constructor(props) {
    super(props)

    // Check if modal should show
    const specialHours = getActiveSpecialHours()
    const hasSeenModal = this.hasSeenModalThisSession()

    this.state = {
      isOpen: specialHours && specialHours.showModal && !hasSeenModal,
    }
  }

  componentDidMount() {
    // Add ESC key listener and prevent body scroll
    if (this.state.isOpen) {
      document.addEventListener('keydown', this.handleEscKey)
      document.body.style.overflow = 'hidden'
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscKey)
    document.body.style.overflow = ''
  }

  componentDidUpdate(prevProps, prevState) {
    // Manage body scroll when modal state changes
    if (this.state.isOpen !== prevState.isOpen) {
      document.body.style.overflow = this.state.isOpen ? 'hidden' : ''
    }
  }

  hasSeenModalThisSession = () => {
    // SSR safety check
    if (typeof window === 'undefined') return true
    return sessionStorage.getItem(MODAL_STORAGE_KEY) === 'true'
  }

  handleEscKey = e => {
    if (e.key === 'Escape') {
      this.closeModal()
    }
  }

  closeModal = () => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(MODAL_STORAGE_KEY, 'true')
    }
    document.removeEventListener('keydown', this.handleEscKey)
    document.body.style.overflow = ''
    this.setState({ isOpen: false })
  }

  render() {
    const specialHours = getActiveSpecialHours()
    if (!specialHours || !this.state.isOpen) return null

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
        }}
        onClick={this.closeModal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        {/* Modal Panel */}
        <div
          className="mx-auto w-full bg-white rounded-lg shadow-lg"
          style={{
            maxWidth: '56rem',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
          }}
          onClick={e => e.stopPropagation()}
        >
          {/* Header */}
          <div
            className="bg-gradient-purple p-4 md:p-6 text-white relative rounded-t-lg"
            style={{ flexShrink: 0 }}
          >
            <h2
              id="modal-title"
              className="text-xl md:text-2xl font-bold text-center text-display pr-8"
            >
              Holiday Open Jump Hours
            </h2>
            <p className="text-center mt-1 text-grey-lightest text-sm md:text-base">
              December 23 - January 3
            </p>
            <button
              onClick={this.closeModal}
              className="absolute text-white hover:text-grey-light transition-all"
              style={{
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                fontSize: '2rem',
                cursor: 'pointer',
                padding: 0,
                lineHeight: 1,
                width: '2rem',
                height: '2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              aria-label="Close modal"
            >
              ×
            </button>
          </div>

          {/* Content - 3-column table */}
          <div className="p-4 md:p-6" style={{ overflowY: 'auto', flex: 1 }}>
            <table className="w-full border-collapse rounded overflow-hidden">
              <thead>
                <tr>
                  <th className="text-center pt-3 pb-2 px-2 font-bold text-white text-sm md:text-base text-display text-shadow bg-grey-darkest leading-none">
                    Date
                  </th>
                  <th className="text-center pt-3 pb-2 px-2 font-bold text-white text-sm md:text-base text-display text-shadow bg-gradient-orange leading-none">
                    Cottage Grove
                  </th>
                  <th className="text-center pt-3 pb-2 px-2 font-bold text-white text-sm md:text-base text-display text-shadow bg-gradient-purple leading-none">
                    DeForest
                  </th>
                </tr>
              </thead>
              <tbody>
                {specialHours.hours[LOCATIONS.COTTAGE_GROVE].map(
                  (cgEntry, idx) => {
                    const dfEntry = specialHours.hours[LOCATIONS.DEFOREST][idx]
                    return (
                      <tr key={idx} className="border-b border-grey-light">
                        <td className="py-2 px-2 font-semibold text-grey-darkest text-xs md:text-sm">
                          {cgEntry.date}
                        </td>
                        <td
                          className={`py-2 px-2 text-xs md:text-sm ${
                            cgEntry.times === 'Closed'
                              ? 'text-grey'
                              : 'text-grey-darkest'
                          }`}
                        >
                          {cgEntry.times}
                        </td>
                        <td
                          className={`py-2 px-2 text-xs md:text-sm ${
                            dfEntry.times === 'Closed'
                              ? 'text-grey'
                              : 'text-grey-darkest'
                          }`}
                        >
                          {dfEntry.times}
                        </td>
                      </tr>
                    )
                  }
                )}
              </tbody>
            </table>

            {/* Footer note */}
            <div className="mt-4 md:mt-6 text-center text-grey-darker">
              <p className="text-xs md:text-sm">
                Price: <OpenJumpPrice /> | All ages welcome
              </p>
            </div>

            {/* Close button */}
            <div className="mt-4 md:mt-6 text-center">
              <button
                onClick={this.closeModal}
                className="px-4 py-2 md:px-6 md:py-3 bg-blue text-white rounded font-semibold hover:shadow-md transition-shadow text-sm md:text-base"
                style={{ cursor: 'pointer' }}
              >
                Got it, thanks!
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
